import { render, staticRenderFns } from "./cModalAddRoles.vue?vue&type=template&id=4835da6a"
import script from "./cModalAddRoles.vue?vue&type=script&lang=js"
export * from "./cModalAddRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports